import script from "./ModalExportSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalExportSuccess.vue?vue&type=script&lang=ts&setup=true"

import "./ModalExportSuccess.vue?vue&type=style&index=0&id=425d695e&lang=scss"

const __exports__ = script;

export default __exports__